<template>
  <Tabs v-model="now" class="main">
    <TabPane label="订单查询" name="1">
      <fff-1 v-if="now=='1'"></fff-1></TabPane
    >
    <TabPane label="已分单配载" name="2">
      <fff-2 v-if="now=='2'"></fff-2>
    </TabPane>
    <TabPane label="无需分单配载" name="3"
      ><fff-3 v-if="now=='3'"></fff-3></TabPane
    >
  </Tabs>
</template>
<script>
import fff1 from "./fendanpeizai1.vue";
import fff2 from "./fendanpeizai2.vue";
import fff3 from "./fendanpeizai3.vue";
export default {
  components:{fff1,fff2,fff3},
  data() {
    return {
      now:'1'
    };
  },
  methods: {},
  watch:{
    now(v){
      console.log(v);
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/wuliu/fahuo/fendanpeizai.vue